import { render, staticRenderFns } from "./AnulacionIndex.vue?vue&type=template&id=f791bf7c&scoped=true"
import script from "./AnulacionIndex.vue?vue&type=script&lang=ts"
export * from "./AnulacionIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f791bf7c",
  null
  
)

export default component.exports